import { useState, useEffect } from 'react';
import { settingService, Setting } from '../services/settingService';

export interface CallStatusOption {
  id: number;
  label: string;
  colorCode?: string;
  settingKey: string;
}

function mapSettingsToOptions(rows: Setting[]): CallStatusOption[] {
  return [...rows]
    .filter((s) => s.is_active)
    .sort((a, b) => (a.display_order ?? 0) - (b.display_order ?? 0))
    .map((s) => ({
      id: s.id,
      label: s.display_name || s.setting_value,
      colorCode: s.color_code,
      settingKey: s.setting_key,
    }));
}

export function useCallStatusOptions(): { options: CallStatusOption[]; loading: boolean } {
  const [options, setOptions] = useState<CallStatusOption[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const rows = await settingService.getByType('call_status');
        const mapped = mapSettingsToOptions(rows || []);
        if (!cancelled) {
          setOptions(mapped);
        }
      } catch {
        if (!cancelled) {
          setOptions([]);
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  return { options, loading };
}

export function getCallStatusOptionById(
  options: CallStatusOption[],
  id?: number | null
): CallStatusOption | undefined {
  if (id == null) return undefined;
  return options.find((o) => o.id === id);
}
